import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormObserverService } from "../../../services/form-observer.service";

@Component({
  selector: 'app-terms-condition',
  templateUrl: './terms-condition.component.html',
  styleUrls: ['./terms-condition.component.scss']
})
export class TermsConditionComponent implements OnInit {
  @Input()  value: boolean;
  @Output()  valueChange = new EventEmitter<boolean>();

  agreedToTermsCondition: boolean = false;
  display: any;
  tc_content: string;
  isChecked: boolean = false;

  constructor(private formFieldObserverService: FormObserverService) {
    this.display = 'none';
  }

  ngOnInit() {
    let tc_content = this.formFieldObserverService.castProperty('termscondition', 'customOptions.tccontent');

    if (typeof tc_content === 'string') {
      this.tc_content = tc_content;
      this.tc_content  = this.tc_content.split("<a ").join("<a target=\"_blank\" "); // Added a default behaviour for links to open in new tab
    }

    this.updateValue(false);
  }

  openModal(){
    this.display= 'block';
  }

  onCloseHandled(){
    this.display= 'none';
  }

  onChange(isChecked) {
    this.value = isChecked;
    this.updateValue(this.value);
  }

  updateValue(payload: boolean) {
    this.value = payload; // Should be updated first
    this.valueChange.emit(payload); // Should be called after this.value update
  }

}
